<template>
  <el-dialog
    title="材料入库"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="task-info-bar">
      <span class="label">材料名称：</span>
      <span class="value">{{ materialName }}</span>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="入库数量" prop="inCount">
        <el-input-number
          v-model="form.inCount"
          :min="1"
          :precision="0"
          placeholder="请输入入库数量"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="入库日期" prop="inDate">
        <el-date-picker
          v-model="form.inDate"
          type="date"
          placeholder="默认当天，可选择具体日期"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="材料来源" prop="supplier">
        <el-input v-model="form.supplier" placeholder="请输入材料来源" maxlength="200" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="备注信息" maxlength="500" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确认入库</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { materialService } from './material.service';

export default {
  name: 'StockInDialog',
  data() {
    return {
      visible: false,
      loading: false,
      materialId: null,
      materialName: '',
      form: {
        materialId: null,
        inCount: null,
        inDate: null,
        supplier: '',
        remark: ''
      },
      rules: {
        inCount: [{ required: true, message: '请输入入库数量', trigger: 'blur' }],
        supplier: [{ required: true, message: '请输入材料来源', trigger: 'blur' }]
      }
    };
  },
  methods: {
    open(row) {
      this.visible = true;
      this.materialId = row.uuid;
      this.materialName = row.materialName;
      this.form = { materialId: row.uuid, inCount: null, inDate: null, supplier: '', remark: '' };
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleClose() {
      this.visible = false;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        materialService.stockIn(this.form).then(() => {
          this.$message.success('入库成功');
          this.handleClose();
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.task-info-bar {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #606266;

  .label { color: #909399; }
  .value { font-weight: 500; }
}
</style>
